<template>
  <form @submit.prevent>
    <LocalGrouperServiceForm
      :service-type="serviceType"
      :application="application"
      :enable-view-picker="false"
      :default-values="defaultValues"
      @table-changed="handleTableChange"
      @values-changed="emitServiceChange($event)"
    ></LocalGrouperServiceForm>
    <FormGroup
      small-label
      :label="$t(`${translationPrefix}.rowsLabel`)"
      :helper-text="
        $t(`${translationPrefix}.rowsHelper`, {
          limit: batchOperationSizeLimit,
        })
      "
      class="margin-bottom-2"
      required
    >
      <InjectedFormulaInput
        v-model="values.rows"
        :disabled="!selectedTableId"
        allow-node-selection="array"
        :placeholder="$t(`${translationPrefix}.rowsPlaceholder`)"
      />
    </FormGroup>
    <div v-if="tableLoading" class="loading-spinner margin-bottom-1"></div>
    <p v-if="selectedIntegrationId && !selectedTableId">
      {{ $t('localGrouperUpsertRowServiceForm.noTableSelectedMessage') }}
    </p>
  </form>
</template>

<script>
import _ from 'lodash'
import form from '@grouper/modules/core/mixins/form'
import InjectedFormulaInput from '@grouper/modules/core/components/formula/InjectedFormulaInput'
import LocalGrouperServiceForm from '@grouper/modules/integrations/localGrouper/components/services/LocalGrouperServiceForm'

export default {
  name: 'LocalGrouperCreateRowsServiceForm',
  components: {
    InjectedFormulaInput,
    LocalGrouperServiceForm,
  },
  mixins: [form],
  props: {
    application: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    service: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    serviceType: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  emits: ['values-changed'],
  data() {
    return {
      allowedValues: ['rows'],
      values: {
        rows: {},
      },
      state: null,
      tableLoading: false,
    }
  },
  computed: {
    translationPrefix() {
      return this.serviceType?.type === 'local_grouper_update_rows'
        ? 'localGrouperUpdateRowsServiceForm'
        : 'localGrouperCreateRowsServiceForm'
    },
    batchOperationSizeLimit() {
      return this.$config.public.integrationLocalGrouperBatchOperationSizeLimit
    },
    selectedIntegrationId() {
      return this.values.integration_id || this.service?.integration_id || null
    },
    selectedTableId() {
      return this.values.table_id || this.service?.table_id || null
    },
  },
  watch: {
    loading: {
      handler(value) {
        if (!value) {
          this.tableLoading = false
        }
      },
    },
  },
  methods: {
    handleTableChange() {
      this.tableLoading = true
    },
    emitServiceChange(newValues) {
      if (this.isFormValid()) {
        const differences = Object.fromEntries(
          Object.entries(newValues).filter(
            ([key, value]) => !_.isEqual(value, this.defaultValues[key])
          )
        )
        if (Object.keys(differences).length > 0) {
          this.$emit('values-changed', differences)
        }
      }
    },
  },
}
</script>
